import { Observable } from 'rxjs';

export interface DivisionDistrictMap {
  id?: any;
  divisionId: any;
  districtId: any;
  districtName?: string;
  isActive: boolean;
  createdBy?: number;
}

export abstract class DivisionDistrictMapData {
  abstract list(url: string): Observable<any>;
  abstract getById(url: string): Observable<DivisionDistrictMap>;
  abstract create(url: string, data: DivisionDistrictMap): Observable<any>;
  abstract update(url: string, data: DivisionDistrictMap): Observable<any>;
}
